import { createSlice } from '@reduxjs/toolkit';

export const SUPPORTED_LANGUAGES = ['en', 'ar'];
export const normalizeLanguage = (language) => {
  const baseLanguage = language?.split('-')[0];
  return SUPPORTED_LANGUAGES.includes(baseLanguage) ? baseLanguage : 'en';
};

const getLanguageFromStorage = () => {
  try {
    return normalizeLanguage(localStorage.getItem('language') || 'en');
  } catch (error) {
    return 'en';
  }
};

const initialState = {
  selectedLanguage: getLanguageFromStorage(),
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      const language = normalizeLanguage(action.payload);
      state.selectedLanguage = language;
      localStorage.setItem('language', language);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
